export const palletTypeOptions = [
  {
    "label": "Grade A",
    "value": "GRADE_A_48x40"
  },
  {
    "label": "Grade A1",
    "value": "GRADE_A1_48x40"
  },
  {
    "label": "Grade B",
    "value": "GRADE_B_48x40"
  },
  {
    "label": "Odd",
    "value": "ODD"
  },
  {
    "label": "Scrap",
    "value": "SCRAP"
  },
]

export const RescheduleModalRadioConstants = [
  {
    value: 'cancel',
    label: 'Cancel Order',
  },
  {
    value: 'reschedule',
    label: 'Reschedule Order',
  }
]

export const claimTypeConstants = [
  {
    value: 'qtyClaimType',
    label: 'Incorrect Quantity',
  },
  {
    value: 'docClaimType',
    label: 'Incorrect BOL',
  }
]